/*
|--------------------------------------------------------------------------
| Local Storage
|--------------------------------------------------------------------------
*/

/**
 * Local Storage
 */
__gh__webApp.localStorage = {
	"init":function(){
		this.bindEvents();
	},
	"getItem":function(keyName){
		if (typeof localStorage[keyName] == "undefined"){
			console.log("Error: Can't get local storage item. Item not set");
		}
		return localStorage.getItem(keyName);

	},
	"setItem":function(keyName,keyValue){
		localStorage.setItem(keyName,keyValue);
	},
	"removeItem":function(keyName){
		if (typeof localStorage[keyName] == "undefined"){
			console.log("Error: Can't remove local storage item. Item not set");
		}
		localStorage.removeItem(keyName);
	},
	"bindEvents":function(){
		var storage = this;
		$(document).on("click","[data-gh-local-storage-key]",function(){
			var keyName 	= $(this).data("gh-local-storage-key"),
				keyValue	= $(this).data("gh-local-storage-value");

			storage.setItem(keyName,keyValue);
		});
	}

};

